import { Bubble, mixins } from 'vue-chartjs'
import { commaFormatString, isDecimal } from '@/helpers'

export default Bubble.extend({
  mixins: [mixins.reactiveProp],
  props: {
    axises: {
      type: Object,
      required: true
    }
  },
  computed: {
    options () {
      return {
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 10,
            bottom: 0
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              tickMarkLength: 5,
              color: '#000'
            },
            ticks: {
              fontSize: 10,
              min: this.axises.x.min,
              max: this.axises.x.max
            }
          }],
          yAxes: [{
            gridLines: {
              tickMarkLength: 5,
              color: '#000'
            },
            ticks: {
              fontSize: 10,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function (value, index, values) {
                return index === 0 ? '' : isDecimal(value) ? value.toFixed(1) : value
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontSize: 10,
          bodySpacing: 1,
          displayColors: false,
          footerFontSize: 9,
          footerFontStyle: 'normal',
          titleFontSize: 10,
          titleSpacing: 0,
          titleMarginBottom: 2,
          labelFontSize: 10,
          footerMarginTop: 3,
          xPadding: 4,
          yPadding: 4,
          cornerRadius: 3,
          callbacks: {
            title: function (tooltip, data) {
              return `${data.datasets[tooltip[0].datasetIndex].title}`
            },
            label: function (tooltip, data) {
              return `${commaFormatString(String(data.datasets[tooltip.datasetIndex].label))}`
            },
            footer: function (tooltip, data) {
              return `Rating: ${commaFormatString(tooltip[0].xLabel.toFixed(3))} Index: ${commaFormatString(String(tooltip[0].yLabel))}`
            }
          }
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
})



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/dayParts/DayPartsGraph.js